import React from "react";
import { Button } from "reactstrap";
import styled from "styled-components";

// Mesmo formato do ManualOperationAlert, em âmbar em vez de vermelho: aqui não é
// pendência que trava operação, é proposta que o operador resolve quando quiser.
const Alert = styled.div`
  position: relative;
  background-color: #ffaa00;
  border-radius: 0 10px 10px 0;
  width: auto;
  min-height: 50px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px 0 20px;

  transform: translate(${({ open }) => (open ? "0%" : "calc(-100% - 80px - 25px)")});
  transition: all 0.3s ease-in;
`;

const Message = styled.p`
  text-transform: uppercase;
  margin: 0px 15px;
  font-weight: 500;
  color: #3d2a00;
  font-size: 15px;
`;

const Divider = styled.div`
  border-right: 2px solid #3d2a00;
  height: 18px;
  margin-right: 15px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledButton = styled(Button)`
  margin: 10px;
  color: #3d2a00 !important;
  background-color: #fff !important;
`;

const Counter = styled.div`
  border-radius: 25px;
  background-color: #2f4050;
  display: ${({ show }) => (show ? "flex" : "none")};
  position: absolute;
  top: -10px;
  right: -10px;
  height: 25px;
  min-width: 25px;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #fff;
  padding: 5px;
`;

const RefillEntryAlert = ({ amount, onOpen }) => (
  <Alert open={amount > 0}>
    <Message>Abastecimento de silo</Message>
    <ButtonContainer>
      <Divider />
      <StyledButton onClick={onOpen} className="btn-sm">REGISTRAR</StyledButton>
    </ButtonContainer>
    <Counter show={amount > 1}>{amount}</Counter>
  </Alert>
);

export default RefillEntryAlert;
